import { useEffect, useRef } from 'react';

// Re-runs retryFn the moment the browser comes back online, but only if shouldRetry
// is true at that moment (e.g. the last fetch attempt failed and left no data to show).
export default function useRetryOnReconnect(retryFn, shouldRetry) {
  const retryFnRef = useRef(retryFn);
  useEffect(() => { retryFnRef.current = retryFn; }, [retryFn]);

  const shouldRetryRef = useRef(shouldRetry);
  useEffect(() => { shouldRetryRef.current = shouldRetry; }, [shouldRetry]);

  useEffect(() => {
    const handleOnline = () => {
      if (shouldRetryRef.current) {
        retryFnRef.current();
      }
    };
    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, []);
}
